module.exports = __webpack_public_path__ + "static/media/cal-medical-association-2.0ea01cd8.jpg";